export const enum FeatureFlagsActionTypes {
  FETCH_FLAGS = '@@feature-flags/FETCH_FLAGS',
  SET_FLAGS = '@@feature-flags/SET_FLAGS'
}

// ADD NEW FEATURE FLAGS HERE
export interface IFeatureFlagsState {
  readonly isLoading: boolean;
  readonly LocalizationV2: boolean;
  readonly BingAdsOfferEnabled: boolean;
  readonly UHFEnabled: boolean;
  readonly TSEnabled: boolean;
  readonly M365CopilotOfferUpdateEnabled: boolean;
  readonly D365CopilotOfferUpdateEnabled: boolean;
  readonly MC4NPOfferUpdateEnabled: boolean;
  readonly ModernSponsorshipPhase1: boolean;
  readonly M365CopilotDiscountOfferEnabled: boolean;
  readonly goodstackEnabled: boolean;
  readonly AccountGuardExpansionEnabled: boolean;
  readonly BusinessPremiumAndE1NPGrantSunsetEnabled: boolean;
  readonly tradescreeningPhaseTwoEnabled: boolean;
  readonly AVSEnabled: boolean;
  readonly avsResponseRulesEnabled: boolean;
  readonly RtfpEnabled: boolean;
  readonly regEditv2Enabled: boolean;
  readonly ContactUsAgentEnabled: boolean;
  readonly enableMultiRegIdSelection: boolean;
  readonly EligibilityPreCheckSectionEnabled: boolean;
  readonly profilePageEnhancementsEnabled: boolean;
  readonly ProfileAttestationEnabled: boolean;
  readonly feedbackLoopEnabled: boolean;
  readonly profileEnhancementsPhase2Enabled: boolean;
  readonly BusinessStandardPriceUpdateEnabled: boolean;
}
